import {
  HTTP_DELIVERDT_FETCHING,
  HTTP_DELIVERDT_SUCCESS,
  HTTP_DELIVERDT_FAILED
} from '../constants';

const initialState = {
  result: null,
  isFatching: false,
  isError: false
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_DELIVERDT_FETCHING:
      return { ...state, result: [], isFetching: true, isError: false };
    case HTTP_DELIVERDT_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    case HTTP_DELIVERDT_FAILED:
      return { ...state, result: [], isFetching: false, isError: true };

    default:
      return state;
  }
};
